import { useTranslation } from 'react-i18next';
import {
    mdiChevronRight,
    mdiSchool,
    mdiSeat,
    mdiTransitConnectionVariant,
} from '@mdi/js';

import { Icon } from 'common/components/Icon';
import { Link } from 'common/components/Link';
import {
    ListItem,
    ListItemActionText,
    ListItemMedia,
    ListItemSecondaryAction,
    ListItemText,
} from 'common/components/ListItem';
import { IOfferEventType } from 'graphql/types';
import { getOfferDateDisplay } from 'offer/utils/dates';
import { IOfferEventBasicListItem } from 'offer/types';

interface IProps {
    offerEvent: IOfferEventBasicListItem;
    withDate?: boolean;
    py?: number;
    onClick?(): void;
}

export const OfferEventBasicListItem = ({
    offerEvent,
    withDate,
    ...other
}: IProps) => {
    const [translate] = useTranslation();

    const { offerEventTitle, type, firstDate, offer, image } = offerEvent;

    const title = offerEventTitle || offer?.title;

    let iconPath: string | undefined;

    if (type === IOfferEventType.Training) {
        iconPath = mdiTransitConnectionVariant;
    } else if (
        type === IOfferEventType.Meeting ||
        type === IOfferEventType.Webinar
    ) {
        iconPath = mdiSeat;
    } else if (
        type === IOfferEventType.Course ||
        type === IOfferEventType.Elearning
    ) {
        iconPath = mdiSchool;
    }

    const date =
        withDate && firstDate
            ? getOfferDateDisplay(firstDate, 1, true, true)
            : undefined;

    return (
        <ListItem button component={Link} px={0} {...other}>
            <ListItemMedia
                color="primary"
                image={image?.url || ''}
                size="small"
            >
                {!!iconPath && (
                    <Icon path={iconPath} size="2rem" sizeSm="3rem" />
                )}
            </ListItemMedia>

            <ListItemText primary={title} secondary={date} />

            <ListItemActionText>{translate('open')}</ListItemActionText>

            <ListItemSecondaryAction hideXs>
                <Icon path={mdiChevronRight} size="4rem" />
            </ListItemSecondaryAction>
        </ListItem>
    );
};
